import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IServerOrder } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import LoadingAnimation from 'components/loading-animation';
import GrandTotal from 'pages/cart/your-cart/totals/grand-total';
import TipSelector from 'pages/cart/your-cart/totals/tip-selector';
import { ServiceMode, useOrderContext } from 'state/order';

import { useTotalTipCalculations } from '../../your-cart/totals/use-total-tip-calculations';

import { TotalsContainer } from './styled';
import { TipLabel } from './tip-label';

const Tip = styled.div`
  display: flex;
  justify-content: space-between;
`;

export interface ITotals {
  order: any; // TODO: order context still needs to be typed :grimacing:
  serverOrder: IServerOrder | null;
  rewardApplied?: boolean;
  serviceMode: ServiceMode | null;
  isDisabled: boolean;
}

export const Totals: FC<ITotals> = ({ serverOrder, serviceMode, isDisabled }) => {
  const { formatMessage } = useIntl();
  const orderContext = useOrderContext();
  const {
    hideTipAmount,
    subTotalCents = 0,
    serverOrderTip,
    additionalDiscountAmount,
    cart,
    loading,
    isDeliveryOrder,
  } = useTotalTipCalculations({ serverOrder, serviceMode });

  if (loading || !serverOrder || (isDeliveryOrder && !serverOrder.delivery)) {
    // if loading is true there may have been a pricing error
    // so we should not attempt to render values that depend
    // on the cart
    return <LoadingAnimation fillColor={Styles.color.primary} />;
  }

  return (
    <TotalsContainer>
      <GrandTotal
        cart={cart}
        serverOrderTip={serverOrderTip}
        tipAmount={isDeliveryOrder && !hideTipAmount ? orderContext.tipAmount : 0}
      />
      {isDeliveryOrder && !hideTipAmount && (
        <>
          <Tip data-testid="tip-amount">
            {formatMessage({ id: 'tip' })}
            <Currency amount={orderContext.tipAmount} />
          </Tip>
          <TipLabel />
          <TipSelector
            subTotalCents={subTotalCents}
            otherDiscountAmount={additionalDiscountAmount}
            showTipPercentage={orderContext.shouldShowTipPercentage(
              subTotalCents + additionalDiscountAmount
            )}
            isDisabled={isDisabled}
          />
        </>
      )}
    </TotalsContainer>
  );
};

export default Totals;
